import GasApi from "./../api/gas";
import { createGasState } from "./../utilities/gas";
export const GET_GAS_DATA_REQUESTED = "gas/GET_GAS_DATA_REQUESTED";
export const GET_GAS_DATA = "gas/GET_GAS_DATA";
export const DOWNLOAD_GAS_XLS = "gas/DOWNLOAD_GAS_XLS";

const initialState = {
  data: {},
  isLoading: false,
  hasData: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_GAS_DATA_REQUESTED:
      return {
        ...state,
        isLoading: true
      };

    case GET_GAS_DATA:
      return {
        ...state,
        isLoading: false,
        hasData: true,
        data: createGasState(action.data)
      };

    case DOWNLOAD_GAS_XLS:
      //"https://apps.zeekgps.com/alpha/GenerarReporte.aspx?sTipoReporte=puntos"
      window.open(
        "https://apps.zeekgps.com/alpha/GenerarReporte.aspx?sTipoReporte=temperatura&fInicial=1517126400000&fFinal=1517128974838&aUnidades=205170098st&zona=-8",
        "_blank"
      );
      return {
        ...state
      };

    default:
      return state;
  }
};

export const getGasData = config => {
  return dispatch => {
    dispatch({
      type: GET_GAS_DATA_REQUESTED
    });

    if (process.env.NODE_ENV === "development") {
      return GasApi.getFakeData(config)
        .then(data => {
          dispatch({
            type: GET_GAS_DATA,
            data: data
          });
        })
        .catch(error => {
          throw error;
        });
    } else {
      return GasApi.getData(config)
        .then(data => {
          dispatch({
            type: GET_GAS_DATA,
            data
          });
        })
        .catch(error => {
          throw error;
        });
    }
  };
};

export const downloadGasXls = () => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_GAS_XLS
    });
  };
};



// WEBPACK FOOTER //
// ./src/modules/gas.js